import { useEffect, useState } from "react";
import { http } from "../lib/api";
import { Header } from "../components/site/Header";
import { StickyBar } from "../components/site/StickyBar";
import { EnquiryDialog } from "../components/site/EnquiryDialog";
import { Hero } from "../components/site/Hero";
import { Tools } from "../components/site/Tools";
import { Plans } from "../components/site/Plans";
import { Track } from "../components/site/Track";
import { Faq } from "../components/site/Faq";
import { Footer } from "../components/site/Footer";
import { Compare, HowItWorks, Licences, FinalCta } from "../components/site/Sections";

export default function Landing() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    http.get("/settings/public").then(({ data }) => setSettings(data)).catch(() => {});
    if (!document.getElementById("rzp-js")) {
      const s = document.createElement("script");
      s.id = "rzp-js"; s.src = "https://checkout.razorpay.com/v1/checkout.js"; s.async = true;
      document.body.appendChild(s);
    }
  }, []);

  if (!settings) {
    return <div className="min-h-screen grid place-items-center text-[#6b6f76]">Loading…</div>;
  }

  return (
    <div className="bg-white">
      <a href="#main" className="skip-link" data-testid="skip-to-content">Skip to content</a>
      <Header />
      <main id="main">
        <Hero settings={settings} />
        <Tools settings={settings} />
        <Compare settings={settings} />
        <HowItWorks />
        <Track />
        <Plans settings={settings} />
        <Faq />
        <Licences />
        <FinalCta />
      </main>
      <Footer settings={settings} />
      <StickyBar />
      <EnquiryDialog settings={settings} />
    </div>
  );
}
